export interface CatalogDork {
  id: string;
  query: string;
  title: string;
  description: string;
  category: 'sensitive-directories' | 'sensitive-files' | 'servers' | 'error-messages' | 'login-pages' | 'network-devices' | 'databases' | 'file-discovery' | 'osint' | 'vulnerabilities';
  tags: string[];
  popularity: number; // 1-100 rating based on usage
  dateAdded: string;
  source?: string;
}

export const popularDorks: CatalogDork[] = [
  // Sensitive Directories
  {
    id: "cat-1",
    query: 'intitle:"Index of" "parent directory"',
    title: "Open Directory Listings",
    description: "Find exposed directory listings with browsable file structures",
    category: "sensitive-directories",
    tags: ["directory", "files", "exposed", "listing"],
    popularity: 98,
    dateAdded: "2020-01-15",
    source: "GHDB"
  },
  {
    id: "cat-2",
    query: 'intitle:"index of" inurl:ftp',
    title: "FTP Directory Listings",
    description: "Discover open FTP servers with directory listings",
    category: "sensitive-directories",
    tags: ["ftp", "directory", "server"],
    popularity: 92,
    dateAdded: "2019-06-20",
    source: "GHDB"
  },
  {
    id: "cat-3",
    query: 'intitle:"index of" ".git"',
    title: "Exposed Git Repositories",
    description: "Find exposed .git folders that may contain source code",
    category: "sensitive-directories",
    tags: ["git", "source-code", "repository"],
    popularity: 95,
    dateAdded: "2021-03-10",
    source: "GHDB"
  },
  {
    id: "cat-4",
    query: 'intitle:"index of" "backup"',
    title: "Backup Directories",
    description: "Locate exposed backup folders and files",
    category: "sensitive-directories",
    tags: ["backup", "files", "sensitive"],
    popularity: 88,
    dateAdded: "2020-05-22"
  },
  {
    id: "cat-5",
    query: 'intitle:"index of" wp-content/uploads',
    title: "WordPress Uploads Directory",
    description: "Find exposed WordPress upload directories",
    category: "sensitive-directories",
    tags: ["wordpress", "uploads", "cms"],
    popularity: 85,
    dateAdded: "2020-08-14"
  },

  // Sensitive Files
  {
    id: "cat-6",
    query: 'filetype:env "DB_PASSWORD"',
    title: "Exposed .env Files",
    description: "Find environment files containing database credentials",
    category: "sensitive-files",
    tags: ["credentials", "database", "config", "env"],
    popularity: 97,
    dateAdded: "2021-01-05",
    source: "GHDB"
  },
  {
    id: "cat-7",
    query: 'filetype:sql "INSERT INTO" password',
    title: "SQL Dumps with Passwords",
    description: "Locate SQL database dumps containing password data",
    category: "sensitive-files",
    tags: ["sql", "database", "passwords", "dump"],
    popularity: 94,
    dateAdded: "2019-11-30",
    source: "GHDB"
  },
  {
    id: "cat-8",
    query: 'filetype:log username password',
    title: "Log Files with Credentials",
    description: "Find log files that accidentally contain login credentials",
    category: "sensitive-files",
    tags: ["logs", "credentials", "username", "password"],
    popularity: 91,
    dateAdded: "2020-02-18"
  },
  {
    id: "cat-9",
    query: 'filetype:conf inurl:web.config',
    title: "Web.config Files",
    description: "Discover exposed ASP.NET configuration files",
    category: "sensitive-files",
    tags: ["config", "asp.net", "iis", "windows"],
    popularity: 86,
    dateAdded: "2019-09-12"
  },
  {
    id: "cat-10",
    query: 'filetype:bak inurl:"htaccess"',
    title: "htaccess Backup Files",
    description: "Find backup copies of Apache htaccess configuration",
    category: "sensitive-files",
    tags: ["apache", "htaccess", "backup", "config"],
    popularity: 82,
    dateAdded: "2020-04-25"
  },
  {
    id: "cat-11",
    query: '"-----BEGIN RSA PRIVATE KEY-----" filetype:key',
    title: "Exposed Private Keys",
    description: "Find exposed RSA private key files",
    category: "sensitive-files",
    tags: ["rsa", "private-key", "ssl", "security"],
    popularity: 93,
    dateAdded: "2021-02-08",
    source: "GHDB"
  },
  {
    id: "cat-12",
    query: 'filetype:pem "PRIVATE KEY"',
    title: "PEM Private Keys",
    description: "Locate exposed PEM certificate private keys",
    category: "sensitive-files",
    tags: ["pem", "certificate", "private-key"],
    popularity: 89,
    dateAdded: "2020-07-19"
  },

  // Login Pages
  {
    id: "cat-13",
    query: 'inurl:"/admin/login" OR inurl:"/administrator/login"',
    title: "Admin Login Panels",
    description: "Find administrative login pages",
    category: "login-pages",
    tags: ["admin", "login", "panel", "authentication"],
    popularity: 96,
    dateAdded: "2019-03-28",
    source: "GHDB"
  },
  {
    id: "cat-14",
    query: 'intitle:"Login" inurl:"/wp-login.php"',
    title: "WordPress Login Pages",
    description: "Discover WordPress admin login pages",
    category: "login-pages",
    tags: ["wordpress", "login", "cms", "admin"],
    popularity: 90,
    dateAdded: "2020-01-10"
  },
  {
    id: "cat-15",
    query: 'inurl:"/phpmyadmin/index.php"',
    title: "phpMyAdmin Panels",
    description: "Find exposed phpMyAdmin database management interfaces",
    category: "login-pages",
    tags: ["phpmyadmin", "database", "mysql", "admin"],
    popularity: 94,
    dateAdded: "2019-07-05",
    source: "GHDB"
  },
  {
    id: "cat-16",
    query: 'intitle:"Dashboard" inurl:"/admin"',
    title: "Admin Dashboards",
    description: "Locate administrative dashboard interfaces",
    category: "login-pages",
    tags: ["dashboard", "admin", "panel"],
    popularity: 87,
    dateAdded: "2020-09-30"
  },

  // Error Messages
  {
    id: "cat-17",
    query: '"SQL syntax" "mysql" filetype:php',
    title: "MySQL Error Messages",
    description: "Find pages exposing MySQL SQL syntax errors",
    category: "error-messages",
    tags: ["sql", "mysql", "error", "php"],
    popularity: 91,
    dateAdded: "2019-05-15",
    source: "GHDB"
  },
  {
    id: "cat-18",
    query: '"Warning: mysql_" OR "Warning: mysqli_"',
    title: "PHP MySQL Warnings",
    description: "Discover PHP pages with MySQL connection warnings",
    category: "error-messages",
    tags: ["php", "mysql", "warning", "debug"],
    popularity: 88,
    dateAdded: "2020-03-22"
  },
  {
    id: "cat-19",
    query: '"ORA-" site:*.edu',
    title: "Oracle Database Errors",
    description: "Find Oracle database error messages on educational sites",
    category: "error-messages",
    tags: ["oracle", "database", "error", "edu"],
    popularity: 79,
    dateAdded: "2019-12-08"
  },
  {
    id: "cat-20",
    query: '"Fatal error: Uncaught exception"',
    title: "PHP Fatal Errors",
    description: "Locate PHP pages with uncaught exception errors",
    category: "error-messages",
    tags: ["php", "error", "exception", "debug"],
    popularity: 84,
    dateAdded: "2020-06-14"
  },

  // Network Devices
  {
    id: "cat-21",
    query: 'intitle:"RouterOS" inurl:"/winbox"',
    title: "MikroTik RouterOS",
    description: "Find MikroTik router administration interfaces",
    category: "network-devices",
    tags: ["mikrotik", "router", "network", "winbox"],
    popularity: 86,
    dateAdded: "2021-01-20",
    source: "GHDB"
  },
  {
    id: "cat-22",
    query: 'intitle:"Cisco" "ASDM"',
    title: "Cisco ASDM Interfaces",
    description: "Discover Cisco Adaptive Security Device Manager interfaces",
    category: "network-devices",
    tags: ["cisco", "firewall", "asdm", "network"],
    popularity: 83,
    dateAdded: "2020-02-28"
  },
  {
    id: "cat-23",
    query: 'intitle:"webcamXP 5"',
    title: "WebcamXP Cameras",
    description: "Find exposed WebcamXP surveillance cameras",
    category: "network-devices",
    tags: ["webcam", "camera", "surveillance", "iot"],
    popularity: 90,
    dateAdded: "2019-08-17",
    source: "GHDB"
  },
  {
    id: "cat-24",
    query: 'inurl:"/view/view.shtml" OR inurl:"ViewerFrame?Mode"',
    title: "IP Cameras",
    description: "Locate exposed IP camera streams",
    category: "network-devices",
    tags: ["camera", "ip-camera", "surveillance", "stream"],
    popularity: 92,
    dateAdded: "2020-04-05"
  },
  {
    id: "cat-25",
    query: 'intitle:"printer" "status" inurl:"/hp/device"',
    title: "HP Printer Status Pages",
    description: "Find HP printer administration and status pages",
    category: "network-devices",
    tags: ["printer", "hp", "network", "iot"],
    popularity: 78,
    dateAdded: "2019-10-22"
  },

  // Databases
  {
    id: "cat-26",
    query: 'inurl:":9200/_cat"',
    title: "Elasticsearch Clusters",
    description: "Find exposed Elasticsearch cluster endpoints",
    category: "databases",
    tags: ["elasticsearch", "database", "nosql", "api"],
    popularity: 93,
    dateAdded: "2021-02-14",
    source: "GHDB"
  },
  {
    id: "cat-27",
    query: 'inurl:":27017" "mongodb"',
    title: "MongoDB Instances",
    description: "Discover exposed MongoDB database instances",
    category: "databases",
    tags: ["mongodb", "database", "nosql"],
    popularity: 91,
    dateAdded: "2020-05-30"
  },
  {
    id: "cat-28",
    query: 'intitle:"Kibana" inurl:"/app/kibana"',
    title: "Kibana Dashboards",
    description: "Find exposed Kibana visualization dashboards",
    category: "databases",
    tags: ["kibana", "elasticsearch", "dashboard", "logs"],
    popularity: 88,
    dateAdded: "2020-08-20"
  },
  {
    id: "cat-29",
    query: 'inurl:":5984/_utils"',
    title: "CouchDB Futon Interface",
    description: "Locate exposed CouchDB administration interfaces",
    category: "databases",
    tags: ["couchdb", "database", "nosql", "admin"],
    popularity: 80,
    dateAdded: "2019-11-15"
  },

  // File Discovery
  {
    id: "cat-30",
    query: 'filetype:xlsx "confidential" OR "internal use only"',
    title: "Confidential Excel Files",
    description: "Find Excel spreadsheets marked as confidential",
    category: "file-discovery",
    tags: ["excel", "spreadsheet", "confidential", "internal"],
    popularity: 89,
    dateAdded: "2020-01-25",
    source: "GHDB"
  },
  {
    id: "cat-31",
    query: 'filetype:pdf "password" "username"',
    title: "PDFs with Credentials",
    description: "Discover PDF documents containing credential information",
    category: "file-discovery",
    tags: ["pdf", "credentials", "password", "document"],
    popularity: 86,
    dateAdded: "2020-06-08"
  },
  {
    id: "cat-32",
    query: 'filetype:docx "draft" "not for distribution"',
    title: "Draft Documents",
    description: "Find draft Word documents not meant for distribution",
    category: "file-discovery",
    tags: ["word", "draft", "document", "internal"],
    popularity: 75,
    dateAdded: "2019-09-05"
  },
  {
    id: "cat-33",
    query: 'filetype:csv "email" "phone"',
    title: "Contact Lists (CSV)",
    description: "Locate CSV files containing contact information",
    category: "file-discovery",
    tags: ["csv", "contacts", "email", "data"],
    popularity: 84,
    dateAdded: "2020-11-12"
  },

  // OSINT
  {
    id: "cat-34",
    query: 'site:linkedin.com "CEO" "email"',
    title: "LinkedIn CEO Profiles",
    description: "Find CEO profiles with contact information on LinkedIn",
    category: "osint",
    tags: ["linkedin", "ceo", "executive", "contact"],
    popularity: 87,
    dateAdded: "2020-03-15"
  },
  {
    id: "cat-35",
    query: 'site:pastebin.com "password" "gmail.com"',
    title: "Pastebin Credential Leaks",
    description: "Search Pastebin for leaked Gmail credentials",
    category: "osint",
    tags: ["pastebin", "leak", "credentials", "gmail"],
    popularity: 94,
    dateAdded: "2019-07-22",
    source: "GHDB"
  },
  {
    id: "cat-36",
    query: 'site:github.com "api_key" OR "apikey" filetype:json',
    title: "GitHub API Keys",
    description: "Find exposed API keys in GitHub JSON files",
    category: "osint",
    tags: ["github", "api-key", "leak", "json"],
    popularity: 96,
    dateAdded: "2021-01-08",
    source: "GHDB"
  },
  {
    id: "cat-37",
    query: 'site:trello.com "password" OR "credentials"',
    title: "Trello Board Leaks",
    description: "Discover public Trello boards with sensitive information",
    category: "osint",
    tags: ["trello", "leak", "password", "public"],
    popularity: 85,
    dateAdded: "2020-09-18"
  },
  {
    id: "cat-38",
    query: 'site:docs.google.com "confidential" OR "internal"',
    title: "Public Google Docs",
    description: "Find publicly accessible confidential Google documents",
    category: "osint",
    tags: ["google-docs", "public", "confidential", "leak"],
    popularity: 88,
    dateAdded: "2020-04-28"
  },

  // Vulnerabilities
  {
    id: "cat-39",
    query: 'inurl:".php?id=" site:*.edu',
    title: "SQL Injection Candidates (EDU)",
    description: "Find potential SQL injection points on educational sites",
    category: "vulnerabilities",
    tags: ["sqli", "injection", "php", "edu"],
    popularity: 90,
    dateAdded: "2019-06-10",
    source: "GHDB"
  },
  {
    id: "cat-40",
    query: 'inurl:"file=" ext:php',
    title: "LFI Candidates",
    description: "Locate potential Local File Inclusion vulnerabilities",
    category: "vulnerabilities",
    tags: ["lfi", "inclusion", "php", "vulnerability"],
    popularity: 89,
    dateAdded: "2020-02-05"
  },
  {
    id: "cat-41",
    query: 'inurl:"page=" OR inurl:"url=" ext:php',
    title: "RFI/SSRF Candidates",
    description: "Find potential Remote File Inclusion or SSRF points",
    category: "vulnerabilities",
    tags: ["rfi", "ssrf", "php", "vulnerability"],
    popularity: 87,
    dateAdded: "2020-07-14"
  },
  {
    id: "cat-42",
    query: 'inurl:"/wp-content/plugins/" "readme.txt"',
    title: "WordPress Plugin Info",
    description: "Discover WordPress plugin readme files for version enumeration",
    category: "vulnerabilities",
    tags: ["wordpress", "plugin", "version", "enumeration"],
    popularity: 83,
    dateAdded: "2019-12-20"
  },
  {
    id: "cat-43",
    query: '"Powered by" "v1." OR "v2." inurl:"/admin"',
    title: "Outdated Admin Panels",
    description: "Find potentially outdated admin panels by version numbers",
    category: "vulnerabilities",
    tags: ["version", "outdated", "admin", "enumeration"],
    popularity: 76,
    dateAdded: "2020-10-08"
  },

  // Additional Popular Dorks
  {
    id: "cat-44",
    query: 'site:*.s3.amazonaws.com filetype:pdf',
    title: "AWS S3 PDF Files",
    description: "Find PDF files stored on public AWS S3 buckets",
    category: "file-discovery",
    tags: ["aws", "s3", "cloud", "pdf"],
    popularity: 91,
    dateAdded: "2021-03-05",
    source: "GHDB"
  },
  {
    id: "cat-45",
    query: 'site:drive.google.com "password"',
    title: "Google Drive Password Files",
    description: "Search Google Drive for publicly shared password files",
    category: "osint",
    tags: ["google-drive", "password", "leak", "cloud"],
    popularity: 88,
    dateAdded: "2020-08-25"
  },
  {
    id: "cat-46",
    query: 'intitle:"Apache2 Ubuntu Default Page"',
    title: "Default Apache Pages",
    description: "Find servers with default Apache installation pages",
    category: "servers",
    tags: ["apache", "default", "ubuntu", "misconfiguration"],
    popularity: 82,
    dateAdded: "2019-10-30"
  },
  {
    id: "cat-47",
    query: 'intitle:"Welcome to nginx!"',
    title: "Default Nginx Pages",
    description: "Locate servers with default Nginx welcome pages",
    category: "servers",
    tags: ["nginx", "default", "server", "misconfiguration"],
    popularity: 80,
    dateAdded: "2020-01-18"
  },
  {
    id: "cat-48",
    query: '"phpinfo()" filetype:php',
    title: "PHP Info Pages",
    description: "Find exposed PHP info pages revealing server configuration",
    category: "servers",
    tags: ["php", "phpinfo", "config", "server"],
    popularity: 93,
    dateAdded: "2019-04-12",
    source: "GHDB"
  },
  {
    id: "cat-49",
    query: 'inurl:"/server-status" "Apache Server Status"',
    title: "Apache Server Status",
    description: "Discover exposed Apache server status pages",
    category: "servers",
    tags: ["apache", "status", "monitoring", "exposed"],
    popularity: 85,
    dateAdded: "2020-05-07"
  },
  {
    id: "cat-50",
    query: 'site:exploit-db.com "Google Dork"',
    title: "ExploitDB Dorks",
    description: "Find Google Dorks documented on ExploitDB",
    category: "osint",
    tags: ["exploitdb", "ghdb", "dorks", "security"],
    popularity: 95,
    dateAdded: "2021-02-20",
    source: "GHDB"
  },

  // ===== Expanded Catalogue: Proven Working Dorks =====

  // Cloud & Storage Buckets
  { id: "cat-51", query: 'site:s3.amazonaws.com intitle:"index of"', title: "Open AWS S3 Buckets", description: "Find publicly listable Amazon S3 buckets", category: "sensitive-directories", tags: ["aws","s3","cloud","bucket"], popularity: 96, dateAdded: "2022-01-10", source: "GHDB" },
  { id: "cat-52", query: 'site:blob.core.windows.net intitle:"index of"', title: "Open Azure Blob Containers", description: "Discover publicly listable Azure blob storage", category: "sensitive-directories", tags: ["azure","blob","cloud"], popularity: 90, dateAdded: "2022-02-15" },
  { id: "cat-53", query: 'site:storage.googleapis.com intitle:"index of"', title: "Open Google Cloud Storage", description: "Find publicly listable GCS buckets", category: "sensitive-directories", tags: ["gcp","google","cloud","bucket"], popularity: 89, dateAdded: "2022-02-20" },
  { id: "cat-54", query: 'site:digitaloceanspaces.com intitle:"index of"', title: "Open DigitalOcean Spaces", description: "Find publicly listable DigitalOcean Spaces buckets", category: "sensitive-directories", tags: ["digitalocean","spaces","cloud"], popularity: 82, dateAdded: "2022-05-11" },

  // Secrets & Credentials in Public Code
  { id: "cat-55", query: 'site:github.com "AKIA" filetype:env', title: "AWS Access Keys on GitHub", description: "Find leaked AWS access key IDs in .env files", category: "osint", tags: ["github","aws","akia","secrets","leak"], popularity: 97, dateAdded: "2022-03-01", source: "GHDB" },
  { id: "cat-56", query: 'site:github.com "BEGIN OPENSSH PRIVATE KEY"', title: "SSH Private Keys on GitHub", description: "Discover leaked OpenSSH private keys in public repos", category: "osint", tags: ["github","ssh","private-key","leak"], popularity: 95, dateAdded: "2022-04-08" },
  { id: "cat-57", query: 'site:pastebin.com "smtp" "password"', title: "SMTP Credentials on Pastebin", description: "Find leaked SMTP credentials posted to Pastebin", category: "osint", tags: ["pastebin","smtp","credentials","leak"], popularity: 87, dateAdded: "2021-10-22" },
  { id: "cat-58", query: 'site:gitlab.com "api_key" OR "apikey" filetype:yml', title: "GitLab API Keys in YAML", description: "Locate exposed API keys in GitLab YAML configs", category: "osint", tags: ["gitlab","api-key","yaml","leak"], popularity: 88, dateAdded: "2022-06-14" },
  { id: "cat-59", query: 'site:trello.com inurl:"/b/" "smtp"', title: "Public Trello SMTP Boards", description: "Find Trello boards containing SMTP credentials", category: "osint", tags: ["trello","smtp","leak","public"], popularity: 80, dateAdded: "2022-07-30" },
  { id: "cat-60", query: 'inurl:"/.git/config"', title: "Exposed .git/config", description: "Find exposed Git config files often revealing repo URLs and tokens", category: "sensitive-files", tags: ["git","config","exposed"], popularity: 94, dateAdded: "2021-11-15", source: "GHDB" },
  { id: "cat-61", query: 'inurl:"/.env" intext:"DB_PASSWORD"', title: "Exposed Live .env Files", description: "Find live .env files served by web servers", category: "sensitive-files", tags: ["env","credentials","exposed"], popularity: 96, dateAdded: "2022-01-04", source: "GHDB" },
  { id: "cat-62", query: 'filetype:json "client_secret" "client_id"', title: "OAuth client_secret JSON", description: "Find OAuth credentials in publicly exposed JSON files", category: "sensitive-files", tags: ["oauth","json","client-secret","leak"], popularity: 91, dateAdded: "2022-03-25" },
  { id: "cat-63", query: 'filetype:yml "password:" OR "secret:"', title: "YAML Configs with Secrets", description: "Locate exposed YAML configuration files containing secrets", category: "sensitive-files", tags: ["yaml","config","secrets"], popularity: 89, dateAdded: "2022-04-19" },
  { id: "cat-64", query: 'filetype:xml inurl:"web.config" intext:"connectionString"', title: "ASP.NET Connection Strings", description: "Find ASP.NET web.config with DB connection strings", category: "sensitive-files", tags: ["asp.net","web.config","connection-string"], popularity: 86, dateAdded: "2021-12-20" },
  { id: "cat-65", query: 'ext:ini "[FtpUserSettings]"', title: "FileZilla FTP Credentials", description: "Find exposed FileZilla configuration with FTP credentials", category: "sensitive-files", tags: ["ftp","filezilla","ini","credentials"], popularity: 84, dateAdded: "2020-12-11", source: "GHDB" },

  // Admin & Login Pages
  { id: "cat-66", query: 'intitle:"phpMyAdmin" "Welcome to phpMyAdmin"', title: "Exposed phpMyAdmin Welcome", description: "Find phpMyAdmin instances with no auth wall on welcome page", category: "login-pages", tags: ["phpmyadmin","mysql","admin"], popularity: 92, dateAdded: "2021-09-04" },
  { id: "cat-67", query: 'intitle:"Grafana" inurl:"/login"', title: "Grafana Login Pages", description: "Discover publicly accessible Grafana dashboards", category: "login-pages", tags: ["grafana","monitoring","dashboard"], popularity: 90, dateAdded: "2022-02-02" },
  { id: "cat-68", query: 'intitle:"Jenkins" "Dashboard [Jenkins]"', title: "Open Jenkins Dashboards", description: "Find unauthenticated Jenkins CI dashboards", category: "login-pages", tags: ["jenkins","ci","devops","dashboard"], popularity: 93, dateAdded: "2021-10-28", source: "GHDB" },
  { id: "cat-69", query: 'intitle:"GitLab" inurl:"/users/sign_in"', title: "GitLab Login Pages", description: "Locate GitLab self-hosted login portals", category: "login-pages", tags: ["gitlab","login","source-code"], popularity: 85, dateAdded: "2022-01-30" },
  { id: "cat-70", query: 'inurl:"/manager/html" intitle:"Tomcat"', title: "Apache Tomcat Manager", description: "Find exposed Tomcat manager interfaces", category: "login-pages", tags: ["tomcat","java","manager"], popularity: 91, dateAdded: "2020-11-09", source: "GHDB" },
  { id: "cat-71", query: 'intitle:"Portainer" inurl:"/#/auth"', title: "Portainer Login", description: "Find Portainer container management login pages", category: "login-pages", tags: ["portainer","docker","containers"], popularity: 84, dateAdded: "2022-06-22" },

  // Databases & Data Stores
  { id: "cat-72", query: 'inurl:":8086/query" "influxdb"', title: "InfluxDB HTTP API", description: "Find exposed InfluxDB time-series database APIs", category: "databases", tags: ["influxdb","tsdb","api"], popularity: 82, dateAdded: "2022-04-03" },
  { id: "cat-73", query: 'inurl:":6379" "redis_version"', title: "Exposed Redis Instances", description: "Discover Redis instances responding on the default port", category: "databases", tags: ["redis","nosql","cache"], popularity: 89, dateAdded: "2021-12-01" },
  { id: "cat-74", query: 'intitle:"Solr Admin" inurl:"/solr/#/"', title: "Apache Solr Admin", description: "Find exposed Apache Solr search admin panels", category: "databases", tags: ["solr","search","admin"], popularity: 80, dateAdded: "2022-03-18" },
  { id: "cat-75", query: 'intitle:"Adminer" "Login"', title: "Adminer DB Login", description: "Find Adminer database management login pages", category: "databases", tags: ["adminer","database","login"], popularity: 87, dateAdded: "2021-08-25" },

  // IoT, Cameras, ICS
  { id: "cat-76", query: 'inurl:"/control/userimage.html"', title: "Axis IP Cameras", description: "Find Axis network cameras with exposed user image controls", category: "network-devices", tags: ["axis","camera","ip-camera","iot"], popularity: 90, dateAdded: "2020-10-15", source: "GHDB" },
  { id: "cat-77", query: 'intitle:"Live View / - AXIS"', title: "Axis Live View Cameras", description: "Locate Axis cameras with live view streams", category: "network-devices", tags: ["axis","camera","stream"], popularity: 88, dateAdded: "2020-11-22" },
  { id: "cat-78", query: 'inurl:"/view/index.shtml"', title: "Generic Live Camera Index", description: "Find generic webcam live view index pages", category: "network-devices", tags: ["webcam","live","stream"], popularity: 86, dateAdded: "2021-01-12" },
  { id: "cat-79", query: 'intitle:"Hikvision" "Login"', title: "Hikvision DVR Login", description: "Find Hikvision DVR/NVR login portals", category: "network-devices", tags: ["hikvision","dvr","camera"], popularity: 89, dateAdded: "2022-02-08" },
  { id: "cat-80", query: '"Niagara Web Server" inurl:"/login"', title: "Tridium Niagara ICS", description: "Find Tridium Niagara industrial control system logins", category: "network-devices", tags: ["ics","scada","niagara","industrial"], popularity: 83, dateAdded: "2021-07-19" },

  // Servers & Vulnerable Endpoints
  { id: "cat-81", query: 'intitle:"Test Page for the Nginx HTTP Server"', title: "Nginx Test Pages", description: "Find Nginx default test pages indicating fresh installs", category: "servers", tags: ["nginx","default","misconfiguration"], popularity: 79, dateAdded: "2021-05-04" },
  { id: "cat-82", query: 'inurl:"/wp-json/wp/v2/users"', title: "WordPress User Enumeration", description: "Enumerate WordPress users via the public REST API endpoint", category: "vulnerabilities", tags: ["wordpress","rest-api","enumeration"], popularity: 93, dateAdded: "2021-11-30" },
  { id: "cat-83", query: 'inurl:"/actuator/env" OR inurl:"/actuator/health"', title: "Spring Boot Actuator", description: "Find Spring Boot apps exposing actuator endpoints", category: "vulnerabilities", tags: ["spring","actuator","java","exposed"], popularity: 92, dateAdded: "2022-01-22" },
  { id: "cat-84", query: 'inurl:"/debug/pprof"', title: "Go pprof Debug Endpoints", description: "Find Go applications exposing pprof debug endpoints", category: "vulnerabilities", tags: ["golang","pprof","debug"], popularity: 84, dateAdded: "2022-05-09" },
  { id: "cat-85", query: 'inurl:"/swagger-ui.html"', title: "Exposed Swagger UI", description: "Find exposed Swagger/OpenAPI documentation pages", category: "vulnerabilities", tags: ["swagger","openapi","api","docs"], popularity: 91, dateAdded: "2021-09-17" },
  { id: "cat-86", query: 'inurl:"/graphql" intext:"__schema"', title: "Open GraphQL Endpoints", description: "Find GraphQL endpoints with introspection enabled", category: "vulnerabilities", tags: ["graphql","api","introspection"], popularity: 88, dateAdded: "2022-04-14" },

  // OSINT & People
  { id: "cat-87", query: 'site:linkedin.com/in "security engineer" "@gmail.com"', title: "LinkedIn Security Engineers", description: "Find LinkedIn profiles of security engineers with gmail contacts", category: "osint", tags: ["linkedin","people","recon"], popularity: 86, dateAdded: "2022-02-26" },
  { id: "cat-88", query: 'site:t.me "telegram channel"', title: "Telegram Channels Index", description: "Discover Telegram public channels indexed by Google", category: "osint", tags: ["telegram","channel","social"], popularity: 83, dateAdded: "2022-06-30" },
  { id: "cat-89", query: 'site:scribd.com "confidential"', title: "Scribd Confidential Docs", description: "Find documents marked confidential uploaded to Scribd", category: "osint", tags: ["scribd","document","leak"], popularity: 81, dateAdded: "2021-08-08" },
  { id: "cat-90", query: 'site:web.archive.org "password"', title: "Wayback Machine Password Pages", description: "Search Wayback Machine snapshots for pages mentioning passwords", category: "osint", tags: ["archive","wayback","history"], popularity: 82, dateAdded: "2022-03-12" }
];


export const dorkCategories = [
  { id: 'all', name: 'All Categories', icon: 'Grid' },
  { id: 'sensitive-directories', name: 'Sensitive Directories', icon: 'FolderOpen' },
  { id: 'sensitive-files', name: 'Sensitive Files', icon: 'FileWarning' },
  { id: 'login-pages', name: 'Login Pages', icon: 'LogIn' },
  { id: 'error-messages', name: 'Error Messages', icon: 'AlertTriangle' },
  { id: 'network-devices', name: 'Network Devices', icon: 'Router' },
  { id: 'databases', name: 'Databases', icon: 'Database' },
  { id: 'servers', name: 'Servers', icon: 'Server' },
  { id: 'file-discovery', name: 'File Discovery', icon: 'FileSearch' },
  { id: 'osint', name: 'OSINT', icon: 'Search' },
  { id: 'vulnerabilities', name: 'Vulnerabilities', icon: 'Shield' },
] as const;

export function searchCatalog(query: string): CatalogDork[] {
  if (!query.trim()) return [];
  
  const searchTerms = query.toLowerCase().split(/\s+/);
  
  return popularDorks
    .filter(dork => {
      const searchableText = `${dork.title} ${dork.description} ${dork.query} ${dork.tags.join(' ')}`.toLowerCase();
      return searchTerms.every(term => searchableText.includes(term));
    })
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 10);
}

export function getTopDorks(limit: number = 20): CatalogDork[] {
  return [...popularDorks]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
}

export function getDorksByCategory(category: string): CatalogDork[] {
  if (category === 'all') return popularDorks;
  return popularDorks.filter(dork => dork.category === category);
}
